module.exports = __webpack_public_path__ + "static/img/yonghuxinxi.e831754a.png";